import React, { PureComponent } from 'react'
import { View, TextInput, ScrollView, Platform, Dimensions } from 'react-native'
import KeyboardSpacer from 'react-native-keyboard-spacer'
import styled from 'styled-components/native'

import Button from '../../Atoms/Button'
import InlineError from '../../Atoms/InlineError'
import HeaderBar from '../../Molecules/HeaderBar'
import Logo from '../../Atoms/Logo'

import theme from '../../../styles/theme'

import Clock from '../../Organisms/Header/Clock'
import Touchable from '../../Atoms/Touchable'
import TranslatedText from '../../Atoms/TranslatedText'

import { translate } from '../../../services/translate'

const textAreaHeight = (Dimensions.get('window').height - theme.headerHeight - 100) * 0.4

const Container = styled(View)`
  flex: 1;
  background-color: ${theme.colours.white};
`

const Body = styled(ScrollView)`
  flex: 1;
  padding: ${3 * theme.gutterUnit}px;
  background-color: ${theme.colours.lightgrey};
`

const Footer = styled(View)`

  height: 100px;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: ${theme.colours.black};
`

const NameInput = styled(TextInput)`
  height: 40px;
  width: 300px;
  border-color: ${theme.colours.black};
  border-width: 1px;
  margin: ${theme.gutterUnit}px 0;
  padding: ${theme.gutterUnit}px;
`

const StrategyInput = styled(TextInput)`
  height: ${textAreaHeight}px;
  width: 500px;
  border-color: ${theme.colours.black};
  border-width: 1px;
  margin: ${theme.gutterUnit}px 0;
  padding: ${theme.gutterUnit}px;
  justify-content: flex-start;
  align-items: flex-start;
`

const strategyPlaceholder = `Example strategy:
1. To consistently be the #1 in customer satisfaction
2. To grow profitably by managing both margin and volume.
etc
`

const ClockContainer = styled(View)`
  flex: 1;
  align-items: flex-end;
`

export default class Settings extends PureComponent {
  render () {
    const { error, onConfirm, name, strategy, onNameUpdate, onStrategyUpdate, buttonEnabled, registering, lockScreen } = this.props
    const textAlignVertical = Platform.select({ android: { textAlignVertical: 'top' }, default: {} })
    return (
      <Container>
        <HeaderBar black>
          <Touchable onPress={lockScreen}>
            <Logo />
          </Touchable>
          <ClockContainer>
            <Clock black />
          </ClockContainer>
        </HeaderBar>
        <Body contentContainerStyle={{ alignItems: 'center' }}>
          {error && <InlineError message={error.message} />}
          <TranslatedText size='l' bold value='team.screenHeader' default='BANK DETAILS' />
          <TranslatedText overrides={{ marginTop: 2 * theme.gutterUnit }} value='team.bankNameLabel' default='Bank Name' />
          <NameInput
            onChangeText={onNameUpdate}
            value={name}
            autoCorrect={false}
            underlineColorAndroid='transparent'
            maxLength={8}
          />
          <TranslatedText size='xs' value='team.bankNameHelp' default='Please give your bank a name of 8 characters or less' />
          <TranslatedText overrides={{ marginTop: 2 * theme.gutterUnit }} value='team.strategyLabel' default='Strategy' />
          <View>
            <StrategyInput
              multiline
              underlineColorAndroid='transparent'
              onChangeText={onStrategyUpdate}
              numberOfLines={10}
              placeholder={translate('team.defaultStrategy', strategyPlaceholder)}
              placeholderTextColor='grey'
              autoCorrect={false}
              returnKeyType='done'
              value={strategy}
              maxLength={1000}
              {...textAlignVertical}
            />
          </View>
          <TranslatedText size='xs' value='team.strategyLabelHelp' default='Please limit your strategy to 1000 characters' />
        </Body>
        <Footer>
          <Button
            secondary={buttonEnabled}
            darkgrey={!buttonEnabled}
            rounded
            onPress={onConfirm}
            disabled={!buttonEnabled}
            inProgress={registering}
          >
            <TranslatedText size='xxl' bold white={!buttonEnabled} value='team.startButton' default="LET'S GO" />
          </Button>
        </Footer>
        <KeyboardSpacer topSpacing={Platform.select({ android: -500, default: 0 })} />
      </Container>
    )
  }
}
